import React from 'react'
import * as Contentful from 'contentful'

export type BaseContentfulEntry = Contentful.Entry<unknown>

export type ContentfulEntrySys = Contentful.Sys

export interface EntryContentProps<T extends BaseContentfulEntry> {
  structure: T
}

export interface ContentProps<T extends BaseContentfulEntry> extends EntryContentProps<T> {
  className?: string
}

export interface GenericContentRendererProps<T extends BaseContentfulEntry = BaseContentfulEntry> {
  structure?: T | T[]
}

// #ToDo improve typings to avoid any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RendererComponent<C extends ContentProps<BaseContentfulEntry> = ContentProps<any>> =
  | React.FC<C>
  | React.ComponentClass<C>

export type ContentRendererMap<T extends { [key: string]: RendererComponent }> = {
  [K in keyof T]: RendererComponent
}

export type BuildContentRendererType = <K extends { [key: string]: RendererComponent }>(
  contentTypeMap: ContentRendererMap<K>
) => React.FC<GenericContentRendererProps>
